// extracted by mini-css-extract-plugin
export var videoImg = "styles-module--videoImg--Z6qs0";
export var videoPlayButton = "styles-module--videoPlayButton--1LpNz";
export var videoPlay = "styles-module--videoPlay--2UlB7";
export var videoPreviewCard = "styles-module--videoPreviewCard--1PoCb";
export var videoPreviewText = "styles-module--videoPreviewText--1DRty";
export var videoOverlay = "styles-module--videoOverlay--Yic2N";